<template>
<q-toolbar class="navigation" :class="{'navigation--mobile': !$isDesktop}">
  <nav v-if="$isDesktop" role="navigation">
    <ul v-if="currentUser" class="navigation__nav">
      <li v-if="$can('manage-projects')"
          class="navigation__item"
          :class="{'navigation__item--active': activeSection === 'dashboard'}">
        <a :href="$route('dashboard')" class="navigation__link">
          Dashboard <span v-if="activeSection === 'dashboard'" class="sr-only">huidige pagina</span></a>
      </li>
      <li class="navigation__item"
          :class="{'navigation__item--active': activeSection === 'projects'}">
        <a :href="$route('project.index')" class="navigation__link">
          Projecten <span v-if="activeSection === 'projects'" class="sr-only">huidige pagina</span></a>
      </li>
      <li v-if="$can('manage-rules')"
          class="navigation__item"
          :class="{'navigation__item--active': activeSection === 'rules'}">
        <a :href="$route('rule.index')" class="navigation__link">
          Richtlijnen <span v-if="activeSection === 'rules'" class="sr-only">huidige pagina</span></a>
      </li>
      <li v-else
          class="navigation__item"
          :class="{'navigation__item--active': $route().current('rule.catalog')}">
        <a :href="$route('rule.catalog')" class="navigation__link">
          Richtlijnen <span v-if="$route().current('rule.catalog')" class="sr-only">huidige pagina</span></a>
      </li>
      <li v-if="hasManagementPermissions"
          class="navigation__item"
          :class="{'navigation__item--active': activeSection === 'management'}">
        <button type="button" class="navigation__menu-button">Beheer
          <navigation-menu />
        </button>
      </li>
      <li v-else
          class="navigation__item"
          :class="{'navigation__item--active': $route().current('object.catalog')}">
        <a :href="$route('object.catalog')" class="navigation__link">
          Inrichtingselementen <span v-if="$route().current('object.catalog')" class="sr-only">huidige pagina</span></a>
      </li>
    </ul>
  </nav>

  <q-space v-if="$isDesktop" />

  <search-bar
      class="col-grow q-mr-lg"
      v-if="$isDesktop && currentUser" />
  <common-avatar
      v-if="$isDesktop && currentUser"
      :user="currentUser"
      title="Instellingen"
      size="lg"
      id="navbar-avatar"
      dense
      tabindex="0"
      clickable
      :aria-expanded="hamburgerIsOpen"
  >

    <actionable-menu
        v-model="hamburgerIsOpen"
        target="#navbar-avatar"
    >
      <nav-list-item
          label="Berichten"
          route="auth.notifications"
      />
      <q-separator />
      <nav-list-item
          label="HIOR Support"
          target="_blank"
          href="http://hior.zendesk.com/"
      />
      <nav-list-item
          v-if="hasManuals"
          label="Handleidingen"
          route="manuals"
      />
      <nav-list-item
          v-else
          label="Handleiding"
          target="_blank"
          href="/assets/img/20220177%20HIOR%20uitleg%20redesign%20derden.pdf"
      />
      <q-separator />
      <nav-list-item
          label="Profiel"
          route="auth.edit"
      />
      <nav-list-item
          label="Instellingen"
          route="auth.notification.settings"
      />
      <nav-list-item
          label="Privacy statement"
          route="user_management.privacy-statement"
      />
      <q-separator />
      <nav-list-item
          label="Log uit"
          route="auth.logout"
      />
    </actionable-menu>
  </common-avatar>
  <common-avatar
      v-else-if="$isDesktop && !currentUser"
      :title="currentUser ? 'Instellingen' : 'Inloggen' "
      tabindex="0"
      @click="$goto('auth.login')"
  />

  <icon-button
      v-if="!$isDesktop"
      color="white"
      icon="arrow_back"
      :aria-label=" $isDesktop ? 'Ga een pagina terug' : 'Pagina terug'"
      flat
      dense
      round
      @click="goBack"
  />

  <q-toolbar-title v-if="!$isDesktop" class="text-uppercase">
    <q-avatar square>
      <img class="header--logo" src="/assets/img/HIOR-logo.svg">
    </q-avatar>
    <a :href="$route('homepage')" class="link link--light link--no-underline">{{ title }}</a>
  </q-toolbar-title>

  <icon-button
      v-if="!$isDesktop && currentUser"
      color="white"
      icon="menu"
      aria-label="Open navigatie menu"
      :aria-expanded="!!drawer"
      @click="$emit('update:drawer', !drawer)"
      flat
  />
</q-toolbar>
</template>

<script>
import NavigationMenu from '../nav/NavigationMenu'
import { config } from '~INSTANCE'

export default {
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
    activeSection: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    hamburgerIsOpen: false,
  }),
  components: {
    NavigationMenu,
  },
  emits: ['update:drawer'],
  computed: {
    hasManagementPermissions () {
      return this.$can('manage-objects') || this.$can('manage-categories') || this.$can('manage-phases') ||
          this.$can('manage-maps') || this.$can('manage-users') || this.$can('manage-roles')
    },
    title () {
      return config.title || 'HIOR'
    },
    hasManuals () {
      return !!config.manuals
    },
  },
  methods: {
    goBack () {
      window.history.back()
    },
  },
}
</script>
